import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  saveAsFilter: {
    id: 'saveAsFilter',
    defaultMessage: 'Save as filter',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  createFilter: {
    id: 'createFilter',
    defaultMessage: 'Create new filter',
  },
  editFilter: {
    id: 'editFilter',
    defaultMessage: 'Edit filter',
  },
  filterName: {
    id: 'filterName',
    defaultMessage: 'Filter name',
  },
  filterNameExample: {
    id: 'filterNameExample',
    defaultMessage: 'New employees, Equipment, Contracts, etc.',
  },
});

export default { ...globalIntl, ...m };
